<template>
  <RouterView></RouterView>
  <PWAUpdatePrompt />
  <MaintenanceBanner />
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import PWAUpdatePrompt from "@/components/shared/PWAUpdatePrompt.vue";
import MaintenanceBanner from "@/components/shared/MaintenanceBanner.vue";
</script>

